// extracted by mini-css-extract-plugin
export default {"SectionTitle":"SectionTitle-module-c8cc5f153b3e1f4628d3"};